<template>
  <div>
    <component-wrapper
      :attribute="attribute"
      :attributeName="attributeName"
      :complete-required="completeRequired"
      :entityName="entityName"
      :helpText="helpText"
      :id="id"
      :label="label"
      :shouldRender="shouldRender"
      :required="!!ruleList.length"
      :showHeader="showHeader"
    >
      <v-text-field
        :data-cy="`${entityName}__textFieldEmail--${attributeName}`"
        :disabled="disabled"
        :filled="styleMap.filled"
        :outlined="styleMap.outlined"
        :placeholder="placeholder"
        :rules="ruleList.concat(ruleListDefault)"
        :solo="styleMap.solo"
        clearable
        required
        v-model="value"
      ></v-text-field>
    </component-wrapper>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { validateEmail } from "@/lib/validate";

import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  computed: {
    organization() {
      const { getOrganizationById, organizationId } = this;

      return getOrganizationById(organizationId);
    },
    ...mapGetters({
      getOrganizationById: "organization/getById",
    }),
    ...mapState({
      organizationId: state => state.session.organizationId,
      userList: state => state.user.list,
    }),
  },
  async created() {
    await Promise.all([
      this.getOrganizationList({ reload: false }),
      this.getUserList({ reload: false }),
    ]);
  },
  data() {
    return {
      initialValue: this.entity[this.attributeName],
      ruleListDefault: [
        v => (!!v && v.length > 0) || "Requires a value",
        () => {
          const { id, userList, value } = this;

          if (userList.length < 1) {
            return true;
          }

          const collision = userList.find(user => {
            const collision = user.email === value;

            if (id && id === user.userId) {
              return false;
            }

            return collision;
          });

          if (collision) {
            const { firstName, lastName } = collision;
            return `${value} already taken by ${firstName} ${lastName}`;
          }

          return true;
        },
        v => validateEmail(v) || "Email must be a valid email address",
      ],
    };
  },
  methods: {
    ...mapActions({
      getOrganizationList: "organization/list",
      getUserList: "user/list",
    }),
  },
  mixins: [userInputMixin],
};
</script>
